import BrandApi from '@/services/api/brandApi.js'

const BrandApiService = new BrandApi()

export default {
  props: ['brandId'],

  data() {
    return {
      items: []
    }
  },

  methods: {
    getItems
  },

  mounted() {
    this.getItems()
  }
}

async function getItems() {
  try {
    const { data } = await BrandApiService.getBrandStockist(this.brandId)

    this.items = data
  } catch (error) {
    this.$handleError(this, error)
  }
}
